import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Michael Jackson <span>-</span>
            <br /> thriller
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=sOnqjkJTMaA"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Fernanda Abreu</S.Name>
          <S.Profile>Cantora</S.Profile>
          <S.Text>
            “‘Thriller’, de Michael Jackson! O ano era 1983 e o lançamento desse
            vídeo foi um arraso! Mudou para sempre a concepção da linguagem dos
            videoclipes. Tinha 14 minutos de duração e incluía um roteiro de
            ficção, efeitos sonoros e especiais e uma edição de imagem
            incrível.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
